// extracted by mini-css-extract-plugin
export default {"spot-card":"SpotCard_spot-card__VGmRc","spot-card-image":"SpotCard_spot-card-image__KDEjW","spot-card-badge":"SpotCard_spot-card-badge__-WvQL"};